import { render, staticRenderFns } from "./ProjectsTree.vue?vue&type=template&id=02f22645&scoped=true&lang=pug&"
import script from "./ProjectsTree.vue?vue&type=script&lang=js&"
export * from "./ProjectsTree.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTree.vue?vue&type=style&index=0&id=02f22645&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f22645",
  null
  
)

export default component.exports